import { FC } from 'react';
import { SessionContainerProps } from '../config';
import { observer } from 'mobx-react';
import { useStores } from '../../../hooks/useStores';

export interface ContentText {
  _id: string;
  title: string;
  longDescription: string;
  transcript?: string;
  transcriptVisible?: boolean;
  humanReadableId?: string;
  activityType?: string;
}

export interface ContentTextData extends Record<string, unknown> {
  sessionStepId?: string;
  content?: ContentText;
  inPath?: boolean;
}

const _ContainContentText: FC<SessionContainerProps<ContentTextData>> = ({
  onNext,
  onFinish,
  children,
}) => {
  const rootStore = useStores();
  const contentId = rootStore.treeNav.content.sessionStep?.contentId;
  const content = contentId
    ? rootStore.content.getContent(contentId)
    : undefined;
  const pathId = rootStore.treeNav.content.session?.path;
  const sessionStepId = rootStore.treeNav.content.sessionStep?.ownId;
  const inPath = !!pathId;

  return children({
    onNext,
    onFinish,
    data: {
      content,
      inPath,
      sessionStepId,
    },
  });
};

export const ContainContentText = observer(_ContainContentText);
